import React,{useEffect,useState} from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import loader from '../Assets/Images/Loading_icon.gif'

export default function FoundSectionMain() {

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const[pop,setpop] = useState(false);
   

        useEffect(() => {
    
        setpop(true); 
        document.getElementById('section-menu').style.display = "none";
        GetAddressCB();
         getmethod(); 
         getSectionData();
         setTimeout(()=>{
         setpop(false);
         GetResult();
         document.getElementById('section-menu').style.display = "block";
        
        },1000)

       }, [])


    // function show(){

    //   document.getElementById('displaySec').style.display = "block";

    // }

  
    function GetAddressCB(){

      fetch(`${BASE_URL}/Foundation/GetContributorsTable`, {
    
        method: 'GET',
    
        headers: {
    
          "Content-type": "application/json",
          "Accept": "application/json",
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    
        },
    
        //body:JSON.stringify(data)
    
      }).then(response => response.json())
    
        .then(data => {
          console.log("Data", data);
          //setAddress(data);
          // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          localStorage.setItem("paginationDataCB", JSON.stringify(data));
            }
        );
    
      }  
    
      

  function getmethod(){
    console.log("Token", token)
    fetch(`${BASE_URL}/Foundation/Getfoundationusers`, {
  
      method:'GET',
  
      headers: {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data)
        localStorage.setItem("Data", JSON.stringify(data));
      });
  
    }


    function getSectionData(){
     
      
     let UserId =  localStorage.getItem('UserId');
    
     const body ={
      
      id:UserId
    
     }
     console.log(body);
    
    
      axios({          
         method: "POST", 
         url: `${BASE_URL}/Foundation/GetAssignSections`,      
        //  url: "https://localhost:44312/Api/Tc/Getsectiondata",
         data:body,
         headers: {             
           'Content-Type': 'application/json' , 
           "Authorization": "Bearer " + `${token}`   
         }
       
       })
       .then((response) =>{
        console.log(response.data);
        localStorage.setItem("SectionData", JSON.stringify(response.data));
        //setAbout(response.data)
    
      
         }) 
       
        }

        
    // useEffect(()=>{
        
    //   var sec = localStorage.getItem("SectionData");

    //  if (!sec){

    //     return ('No Assigned Sections')
    //  }

    // },[]);

      function GetResult(){


        let loginrole = localStorage.getItem('RoleId');

          let CheckAdmin = loginrole.includes('01');
          console.log("asdf",CheckAdmin)
          let alldata = localStorage.getItem("Data");
          //console.log(alldata)
          
          
          
          let namedata =  JSON.parse(alldata);
           //console.log(namedata)
          
          let names = namedata&&namedata.map((item) => item.userName);
             //console.log("username",names)
          
             let UserName= names.toString();
             //console.log(UserName)
          
          
          let loginUser =localStorage.getItem('username')
          //console.log(loginUser)
          
          let Nameresult = UserName.includes(loginUser);  
          console.log(Nameresult)  
     
          /*---get section data ---*/


let Usersectiondata =  localStorage.getItem("SectionData");
//console.log(Usersectiondata)


let data =  JSON.parse(Usersectiondata);
 //console.log(data)

let sections = data&&data.map((item) => item.section);
   console.log(sections)

   let sectionstr = sections.toString();
   console.log(sectionstr);



let sectionresultA =sectionstr.includes('Home')
console.log(sectionresultA)
let sectionresultB =sectionstr.includes('Who we Are')
console.log(sectionresultB)
let sectionresultC =sectionstr.includes('Journey and Stories')
console.log(sectionresultC)
let sectionresultD =sectionstr.includes('Differentiators')
console.log(sectionresultD)
let sectionresultE =sectionstr.includes('Contributors')
console.log(sectionresultE)

 //localStorage.setItem('usersection',sectionstr)
 // let sectionresultF=sectionstr.includes('')

//  if(sectionresultF==true)
//  {
//    {
//     localStorage.getItem('usersection').length==0 ? document.getElementById("displaySec").innerHTML = " Sections not assigned for this User..!":
//     document.getElementById("displaySec").innerHTML=""
  
//   }
// }


// if(Nameresult==true && sectionresultF==true){
   
//   document.getElementById('displaySec').style.display = "block";

// }
// else{
//    document.getElementById('displaySec').style.display = "block";
//  }


// if (CheckAdmin=true){
//   document.getElementById('OPTION1').style.display = "block";
//   document.getElementById('OPTION2').style.display = "block";
//   document.getElementById('OPTION3').style.display = "block";
//   document.getElementById('OPTION4').style.display = "block";
//   document.getElementById('OPTION5').style.display = "block";
//   document.getElementById("displaySec").innerHTML = " ";
  
// }
// else{
//   document.getElementById('OPTION1').style.display = "none";
//   document.getElementById('OPTION2').style.display = "none";
//   document.getElementById('OPTION3').style.display = "none";
//   document.getElementById('OPTION4').style.display = "none";
//   document.getElementById('OPTION5').style.display = "none";
// }

if(sectionresultA==true || CheckAdmin==true){
  
  document.getElementById('OPTION1').style.display = "block";
  
}
else{
  document.getElementById('OPTION1').style.display = "none"; 
}

if(sectionresultB==true || CheckAdmin==true){
  
  document.getElementById('OPTION2').style.display = "block";
  
}
else{
  document.getElementById('OPTION2').style.display = "none"; 
}
if(sectionresultC==true || CheckAdmin==true){
 
  document.getElementById('OPTION3').style.display = "block";
}
else{
  document.getElementById('OPTION3').style.display = "none"; 
}
if(sectionresultD==true || CheckAdmin==true){
 
  document.getElementById('OPTION4').style.display = "block";
}
else{
  document.getElementById('OPTION4').style.display = "none"; 
}
if(sectionresultE==true || CheckAdmin==true){
 
  document.getElementById('OPTION5').style.display = "block";
}
else{
  document.getElementById('OPTION5').style.display = "none"; 
}

if(sectionresultA==false&&sectionresultB==false&&sectionresultC==false&&sectionresultD==false&&sectionresultE==false && CheckAdmin==false)
{ 
  
  document.getElementById('OPTION1').style.display = "none";
  document.getElementById('OPTION2').style.display = "none";
  document.getElementById('OPTION3').style.display = "none";
  document.getElementById('OPTION4').style.display = "none";
  document.getElementById('OPTION5').style.display = "none";
  document.getElementById("displaySec").innerHTML = " Sections not assigned for this User..!";
}


}


  

 return (


<div className='foundation-addmain mainimage'>
  
       
    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/Kdp Foundation'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Section</span>
    </div>
    </div>


  {pop?<div className='text-center'><img src={loader} alt="loader" id='loading-Indicator'/></div>
 :null}



<div className='section-responsive'>

<div className='foundation-section' id="section-menu" >
  

<span id='displaySec'></span>
<ul>
   
<li id='OPTION1'><Link to="/FoundSectionHome"><button className='foundation-sec-button btn-hover-shine' type='submit'>Home &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link> </li>

<li id='OPTION2'><Link to="/FoundSectionWhoweare"><button className='foundation-sec-button btn-hover-shine' type='submit'>Who we Are &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>

<li id='OPTION3'><Link to="/FoundSectionJS"><button className='foundation-sec-button' type='submit'>Journey and Stories &nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>

<li id='OPTION4'><Link to="/FoundSectionDifferentiators"><button className='foundation-sec-button' type='submit'>Differentiators &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>

<li id='OPTION5'><Link to="/FoundSectionMainContributors"><button className='foundation-sec-button' type='submit'>Contributors &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>

</ul>



</div>
 
</div>


   
</div>

  )
}
